module.exports = __webpack_public_path__ + "img/A4-south-korea.a6f50eeb.png";